import { Action, createReducer, on } from '@ngrx/store'
import { initialOfflineTrackerState, OfflineTrackerState } from '../state/offline-tracker.state'
import {
  FETCH_OFFLINE_TRACKER_DETAILS_SUCCESS,
  LOAD_OFFLINE_TRACKER_SUMMARY_DETAILS_SUCCESS
} from '../action/offline-tracker.action'

export function offlineTrackerReducer(state: OfflineTrackerState, action: Action) {
  return _offlineTrackerReducer(state, action)
}

const _offlineTrackerReducer = createReducer(
  initialOfflineTrackerState,
  on(FETCH_OFFLINE_TRACKER_DETAILS_SUCCESS, (state, { offlineTracker }) => {
    return {
      ...state,
      details: offlineTracker
    }
  }),
  on(LOAD_OFFLINE_TRACKER_SUMMARY_DETAILS_SUCCESS, (state, data) => {
    return {
      ...state,
      summary: data
    }
  })
)
